import { OrdenItem } from '@services/business/invoice/entities';
import { ApiInterface, EmptyObject } from '@stetamalo/cloud-platform/catalog/api';
import { Schemy } from '@stetamalo/cloud-platform/lib/schemy';
import { ApiConfig } from 'services/support/utils/types/api-config';

export type Interface = ApiInterface<{
  response: OrdenItem[];
  pathParams: EmptyObject;
  body: {
    clientId: string;
    dateInitial: number;
    dateEnd: number;
    categoryId?: string;
    serviceId?: string;
    lashistaId?: string;
    tenantId?: string;
    status?: string;
    projectionExpression?: string[];
    onlyLashista?: boolean;
    type?: string;
  };
  claims: { tenantId: string; isAdmin: string };
  queryParams: EmptyObject;
}>;

export const config: ApiConfig<Interface> = {
  name: 'api-history-client',
  method: 'POST',
  basePath: 'history',
  path: '/client',
  tablePermission: 'readWrite',
  scope: 'RECEPTIONIST',
  schema: Schemy.schema<Interface['body']>({
    clientId: { type: String, required: true },
    tenantId: { type: String },
    dateInitial: { type: Number, required: false },
    dateEnd: { type: Number, required: false },
    status: { type: String },
    lashistaId: { type: String },
    projectionExpression: { type: [String] },
    onlyLashista: { type: Boolean },
    type: { type: String, enum: ['SERVICE', 'PRODUCT'] },
  }),
};
